class ReCaptchaService {
  private static serviceInstance: ReCaptchaService;

  public static get instance() {
    // eslint-disable-next-line no-return-assign
    return this.serviceInstance || (this.serviceInstance = new this());
  }

  public async retrieveReCaptchaToken(): Promise<string | null> {
    return new Promise((resolve) => {
      try {
        (window as any).grecaptcha.ready(() => {
          (window as any).grecaptcha.execute(`${process.env.VUE_APP_RECAPTCHA_SITE_KEY}`, { action: 'submit' })
            .then((token: string) => {
              resolve(token);
            });
        });
      } catch (error) {
        resolve(null);
      }
    });
  }
}

// export a singleton instance in the global namespace
// eslint-disable-next-line import/prefer-default-export
export const reCaptchaService = ReCaptchaService.instance;
